export function organizeFamiliesByGroups(families) {
    const groups = { Unassigned: [] };
    Object.keys(families).forEach((familyKey) => {
        const family = families[familyKey];
        if (family.groups.length === 0) {
            groups.Unassigned.push(family);
        }
        else {
            family.groups.forEach((groupName) => {
                if (!groups[groupName]) {
                    groups[groupName] = [];
                }
                groups[groupName].push(family);
            });
        }
    });
    return groups;
}
